import './../../styles/templates/search.scss';

document.addEventListener("DOMContentLoaded", function () {
    var searchBarDesktop = document.querySelector(".header__right__element.search");

    if (searchBarDesktop) {
        searchBarDesktop.classList.add("hidden");
    }
});